module.exports = __webpack_public_path__ + "static/media/cs-flow-diagram.e3a11e4a.svg";